<p-dialog [(visible)]="displaySearchDialog" [modal]="true" [style]="{width: '650px'}" (onHide)="cancelSearch()">
    <ng-template pTemplate="header">
        <div class="w-full text-center font-22 font-weight-600"translate>customer_mngt.adv_search
        </div>
    </ng-template>
    <div class="formgrid">
            <p-table
                [value]="customers" #tableCustomer [paginator]="true" [lazy]="true"
                (onLazyLoad)="pageChangeEvent($event)" [rows]="pageSizeCustomers" [totalRecords]="totalCustomers"
                [rowsPerPageOptions]="[10,25,50,100]"
                [currentPageReportTemplate]="'{currentPage} of {totalPages}'" [showCurrentPageReport]=true>
                <ng-template pTemplate="header" hidden="true">
                    <tr>
                        <th id="name"><span translate>common.name</span></th>
                        <th id="document"><span translate>customer_mngt.customer_table.document</span></th>
                        <th id="customerNumber"><span translate>customer_mngt.customer_id</span></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-customer let-i="rowIndex">
                    <tr class="{{(selectedCustomer && selectedCustomer.id == customer.id)?'selected-customer':''}}"
                        (click)="selectCustumner(customer)">
                        <td>{{customer.name}}</td>
                        <td>{{customer.document?.serialNumber}}</td>
                        <td>{{customer.customerNumber}}</td>
                    </tr>
                </ng-template>
            </p-table>               
    </div>
    <div class="formgrid grid justify-content-center">
        <div class="field mt-6">
            <app-button id="select-ok-order" buttonClass="btn-primary" buttonType="button"
                        (clickEvent)="onSelect()" [isDisabled]="!selectedCustomer">
                <span translate>buttons.ok</span>
            </app-button>
            <app-button id="select-cancel" buttonClass="btn-secondary mr-0" buttonType="button"
                        (clickEvent)="cancelSearch()">
                <span translate>buttons.cancel</span>
            </app-button>

        </div>
    </div>
</p-dialog>
